<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import '@/common/css/common.css';

  export default {
    name: 'App'
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px;
  }

  .el-popover {
    padding: 0 !important;
    min-width: 0 !important;
    min-height: 0 !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue